import React from 'react';
import { Theme } from '../../shared/types/theme';

interface WhiteSpaceProps {
    theme?: Theme;
    spacing?: string;
}

const DEFAULT_SPACING = `16px`;

const DEFAULT_STYLE = {
    width: `100%`,
    padding: 0,
};

const getWhiteSpaceStyle = (spacing: string) => {
    const isNegative = spacing.startsWith(`-`);
    return {
        height: isNegative ? 0 : spacing,
        marginBottom: isNegative ? spacing : 0,
    };
};

const WhiteSpace = ({ theme = `white`, spacing }: WhiteSpaceProps) => {
    const customStyle = getWhiteSpaceStyle(spacing ?? DEFAULT_SPACING);
    const styles = { ...DEFAULT_STYLE, ...customStyle };

    return <div className={`themed-container ${theme}`} style={styles} />;
};

export default WhiteSpace;
